export default __webpack_public_path__ + "static/animated_logo-53e6086ac81e379887254bc33096c3d8.webm";